<template>
  <div class="layout-wrap">
    <div class="sidebar">
      <div class="sidebar-title">管理后台</div>
      <!-- 菜单列表 -->
      <router-link
        v-for="item in menuList"
        :key="item.path"
        :to="item.path"
        class="menu-item"
        :class="{active: $route.path === item.path}"
      >
        {{ item.name }}
      </router-link>
      <!-- 退出登录 放在侧边栏底部 -->
      <div class="logout-wrap">
        <div class="menu-item" @click="handleLogout">退出登录</div>
      </div>
    </div>
    <div class="main-content">
      <router-view :key="$route.path"></router-view>
    </div>
  </div>
</template>
<script>
export default {
  name: "Layout",
  data() {
    return {
      menuList: [
        { path: "/admin/imgManage", name: "图片管理" },
        { path: "/admin/navManage", name: "导航管理" },
        { path: "/admin/auditMode", name: "审核配置" },
        { path: "/admin/carouselManage", name: "轮播图管理" },
        { path: "/admin/NewsManage", name: "资讯管理" }
      ]
    };
  },
  methods: {
    handleLogout() {
      // 清除本地存储token
      localStorage.removeItem('token')
      // 跳转到登录页，Vue2 + vue-router 原生写法
      this.$router.push('/login')
    }
  }
};
</script>
<style scoped>
.layout-wrap {
  display: flex;
  height: 100vh;
  overflow: hidden;
}
.sidebar {
  width: 220px;
  background-color: #1f2937;
  color: #fff;
  padding-top: 30px;
  display: flex;
  flex-direction: column;
}
.sidebar-title {
  font-size: 24px;
  text-align: center;
  margin-bottom: 40px;
  font-weight: bold;
}
.menu-item {
  display: block;
  color: #e5e7eb;
  text-decoration: none;
  padding: 14px 32px;
  font-size: 17px;
  transition: 0.2s;
  cursor: pointer;
}
.menu-item:hover {
  background: #374151;
}
.menu-item.active {
  background: #2563eb;
  color: #fff;
}
/* 让退出登录固定在侧边栏底部 */
.logout-wrap {
  margin-top: auto;
  padding-bottom: 20px;
}
.main-content {
  flex: 1;
  padding: 30px;
  overflow: auto;
  background: #f5f7fa;
}
</style>
